<app-juvo-dialog
  [isStandaloneOverlay]="false"
  [title]="dialogTitle()"
  [showTitle]="true"
  titleAlign="center"
  [showFooter]="false"
  [showCloseIcon]="true"
  [showBottomBar]="false"
  (cancel)="onClose()"
  type="common-medium"
>
  @if (selectedComponent(); as componentClass) {
    <ng-container
      *ngComponentOutlet="selectedComponent(); inputs: { visitingCheckout, callback: strategy.callback }"
    ></ng-container>
  }
</app-juvo-dialog>
